module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "container-fluid footer"
  }, [_vm._m(0), _vm._v(" "), _vm._c('div', {
    staticClass: "row text-center"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 xs-pb-50"
  }, [_vm._c('router-link', {
    staticClass: "btn-pub btn-pub-default",
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_vm._v("Sign Up For Free")])], 1)]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-md-4 text-center xs-mb-30 "
  }, [_vm._c('span', [_vm._v("We'd love to hear from you")]), _vm._c('br'), _vm._v(" "), _vm._c('div', {
    staticClass: "footer-nav xs-mt-20"
  }, [_vm._c('router-link', {
    attrs: {
      "to": {
        name: 'contact-us'
      }
    }
  }, [_vm._v("Contact us")]), _vm._v(" |\n        "), _vm._c('router-link', {
    attrs: {
      "to": {
        name: 'feedback-form'
      }
    }
  }, [_vm._v("Feedback form")])], 1)]), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-md-4 text-right xs-mb-30"
  }, [_vm._c('span', [_vm._v("Join our mailing list")]), _vm._v(" "), _vm._c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _vm._c('SubscribeForm', {
    staticClass: "sub"
  })], 1)]), _vm._v(" "), _vm._c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6 text-right"
  }, [_vm._v("\n      © Copyright CLEX " + _vm._s(_vm.year) + "\n    ")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "row text-center"
  }, [_vm._c('div', {
    staticClass: "col-xs-12 title-text  xs-pb-50"
  }, [_vm._v("\n      Learn Smarter, Organize Notes, Remember Everything. Get Started With Us, "), _vm._c('strong', [_vm._v("For Free!")])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "col-xs-12 col-md-4 xs-mb-30"
  }, [_vm._c('span', [_vm._v("Follow Us")]), _vm._v(" "), _vm._c('div', {
    staticClass: "social-links"
  }, [_vm._c('a', {
    attrs: {
      "href": "https://facebook.com",
      "target": "_blank"
    }
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/facebook2.png"
    }
  })]), _vm._v(" "), _vm._c('a', {
    attrs: {
      "href": "https://twitter.com",
      "target": "_blank"
    }
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/twitter2.png"
    }
  })]), _vm._v(" "), _vm._c('a', {
    attrs: {
      "href": "https://instagram.com",
      "target": "_blank"
    }
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/instagram2.png"
    }
  })]), _vm._v(" "), _vm._c('a', {
    attrs: {
      "href": "https://youtube.com",
      "target": "_blank"
    }
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/youtube2.png"
    }
  })]), _vm._v(" "), _vm._c('a', {
    attrs: {
      "href": "https://linkedin.com",
      "target": "_blank"
    }
  }, [_vm._c('img', {
    attrs: {
      "src": "/static/img/icons/linkedin2.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    staticClass: "col-xs-12 col-sm-6"
  }, [_vm._c('div', {
    staticClass: "footer-nav"
  }, [_vm._c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.websitepolicies.com/policies/view/ppLviGYs"
    }
  }, [_vm._v("Terms & conditions")]), _vm._v(" |\n        "), _vm._v(" "), _vm._c('a', {
    attrs: {
      "href": "https://www.iubenda.com/privacy-policy/71921731/legal",
      "target": "_blank"
    }
  }, [_vm._v("Privacy Policy")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a1a170a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/temp/home/FooterNav.vue
// module id = 660
// module chunks = 1